import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import Print from "@arcgis/core/widgets/Print";
import { UserInformationService } from "../../../shared/services/user/user-information.service";
import { AppConfig } from "../../../app.config";
import { take, takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../shared/decorators/autounsub.decorator";
import { Subject } from "rxjs";
let PrintComponent = class PrintComponent {
    userInformationService;
    _destroy$ = new Subject();
    constructor(userInformationService) {
        this.userInformationService = userInformationService;
    }
    initializePrintTool(mapView, moduleId) {
        const print = new Print({
            view: mapView,
            printServiceUrl: AppConfig.settings.arcGIS.printServiceURL,
            allowedFormats: ["pdf", "png32", "png8", "jpg", "gif", "eps", "svg", "svgz"],
            templateOptions: {
                layout: "a4-landscape"
            }
        });
        this.userInformationService.$authenticatedUser.pipe(takeUntil(this._destroy$), take(1)).subscribe(user => {
            print.templateOptions.author = `${user.firstName} ${user.lastName}`;
        });
        if (moduleId) {
            this.userInformationService.$systemOrganisations.pipe(take(1)).subscribe(() => {
                const organisationId = this.userInformationService.getOrganisationId(moduleId);
                if (organisationId) {
                    const organisation = this.userInformationService.getOrganisationInformation(organisationId);
                    print.templateOptions.copyright = organisation.name;
                }
            });
        }
        return print;
    }
    static ctorParameters = () => [
        { type: UserInformationService }
    ];
};
PrintComponent = __decorate([
    Injectable({
        providedIn: "root"
    }),
    AutoUnsub()
], PrintComponent);
export { PrintComponent };
